import type {IndexingDim} from "#template/geometry-processing/geometry-graph"
import {classHasMarker} from "#template/role-markers"
import {
    pointGeometryAttributeLikeMarker,
    curveGeometryAttributeLikeMarker,
    meshGeometryAttributeLikeMarker,
} from "#template/nodes/geometry-graph/attribute/attribute-node"
import {
    pointGeometryAttributeSetLikeMarker,
    curveGeometryAttributeSetLikeMarker,
    meshGeometryAttributeSetLikeMarker,
} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"

// Canonical class-level dimension of a geometry-graph node class (0 = point, 1 = curve, 2 = mesh), read
// from the dimension marker the class carries — the class-level source of truth. Returns undefined for
// geometry nodes without a dimension (e.g. dimension-agnostic outputs). The instance/runtime dimension
// lives on the evaluated data as `.dim`; this is its class-queryable counterpart, for classification and
// dispatch (e.g. icons, per-dimension operator handling).
export const getGeometryDimension = (ctor: abstract new (...args: never[]) => unknown): IndexingDim | undefined => {
    if (classHasMarker(ctor, pointGeometryAttributeLikeMarker) || classHasMarker(ctor, pointGeometryAttributeSetLikeMarker)) return 0
    if (classHasMarker(ctor, curveGeometryAttributeLikeMarker) || classHasMarker(ctor, curveGeometryAttributeSetLikeMarker)) return 1
    if (classHasMarker(ctor, meshGeometryAttributeLikeMarker) || classHasMarker(ctor, meshGeometryAttributeSetLikeMarker)) return 2
    return undefined
}
